import { fetchWithAuth } from "../../../../../../api-client/api_client";
import { APIEndpointMethod } from "../../../../../../models/Entities";
import { showErrorToast, showSuccessToast } from "../../../../../shared/Toasts";

interface AbortCommonModelDiffRunProps {
  onSuccess?: () => void;
}

const useAbortCommonModelDiffRun = ({ onSuccess }: AbortCommonModelDiffRunProps) => {
  const headers = {
    "Content-Type": "application/json",
  };

  const abortDiffRun = (diffRunId: string) => {
    if (!diffRunId) {
      return;
    }

    fetchWithAuth({
      path: `/blueprints/cmd-execution/${diffRunId}/abort`,
      method: APIEndpointMethod.POST,
      headers,
      body: {},
      onResponse: () => {
        if (onSuccess) {
          onSuccess();
        }
        showSuccessToast("Common Model diff run successfully aborted");
      },
      onError: (error) => {
        error
          ?.json()
          .then((value: string | Record<string, any>) => {
            let errorMessage = "";
            if (typeof value == "string") {
              errorMessage = value;
            } else {
              errorMessage = value?.non_field_errors ?? JSON.stringify(value);
            }
            showErrorToast(
              `Failed to abort Common Model diff run. Error message: \n ${errorMessage}`
            );
          })
          .catch(() => {
            showErrorToast("Failed to abort Common Model diff run");
          });
      },
    });
  };

  return { abortDiffRun };
};

export default useAbortCommonModelDiffRun;
